import React from 'react';
import {Link, useHistory, useLocation} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';
import styled from 'styled-components';
import {Button} from '@betareader/design-system';

import {updateJoinBetaRequest} from '../../modules/book';
import {removeInvitation} from '../../modules/reader';
import {authUtil} from '../../utils';

const List = styled.ul`
  list-style: none;
  margin: 0;
  max-width: 100%;
  padding: var(--br-space-3);
`;

const Item = styled.li`
  align-items: center;
  border-bottom: 1px solid var(--br-border);
  display: grid;
  gap: var(--br-space-3);
  grid-template-columns: 44px minmax(0, 1fr) auto;
  padding: var(--br-space-3) 0;

  @media (max-width: 600px) {
    grid-template-columns: 44px minmax(0, 1fr);
  }
`;

const Cover = styled.img`
  border-radius: var(--br-control-radius);
  height: 44px;
  object-fit: cover;
  width: 44px;
`;

const Details = styled.div`
  min-width: 0;
  overflow-wrap: anywhere;

  a { color: var(--br-accent); font-weight: 700; }
  p { color: var(--br-muted); margin: var(--br-space-1) 0 0; }
`;

const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: var(--br-space-2);

  @media (max-width: 600px) { grid-column: 2; }
`;

const InvitationsList = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const {t} = useTranslation();
  const user = useSelector(state => state.user.user);
  const invitations = useSelector(state => state.reader.invitations) || [];

  const goToSignIn = () => {
    history.push(`/signin?redirect=${encodeURIComponent(location.pathname + location.search)}`);
  };

  const declineInvitation = async bookId => {
    if (!user) {
      goToSignIn();
      return;
    }
    const idToken = await authUtil.getFreshIdToken();
    dispatch(updateJoinBetaRequest(idToken, bookId, {status: 'DECLINED'}, succeeded => {
      if (succeeded) dispatch(removeInvitation(bookId));
    }));
  };

  return (
    <section>
      <h2 style={{padding: 'var(--br-space-3)'}}>{t('Invitations')}</h2>
      <List>
        {invitations.map(invitation => (
          <Item key={invitation._id}>
            {invitation.cover?.highRes?.url
              ? <Cover alt='' src={invitation.cover.highRes.url} />
              : <span aria-hidden='true' />}
            <Details>
              <Link to={`/books/${invitation._id}`}>{invitation.title}</Link>
              <p>{t('ByAuthor', {_authorName: invitation.authorName})}</p>
              <p>{invitation.wordCount?.toLocaleString()} {t('Words')} · {invitation.chapterCount?.toLocaleString()} {t('Chapters')}</p>
            </Details>
            <Actions>
              <Button variant='danger' size='small' onClick={() => declineInvitation(invitation._id)}>
                {t('Decline')}
              </Button>
              <Button size='small' onClick={() => history.push(`/books/${invitation._id}/overview?show=join`)}>
                {t('Accept')}
              </Button>
            </Actions>
          </Item>
        ))}
      </List>
    </section>
  );
};

export default InvitationsList;
